{
  "_provenance": {
    "ns": "auth",
    "source": "src/pages/{Login,ForgotPassword,ResetPassword,SetNewPassword,MfaVerify,MagicLink}Page.tsx"
  },
  "forgot": {
    "alternateLabel": "Sign in",
    "alternatePrompt": "Remember it now?",
    "backToSignIn": "Back to sign in",
    "checkYourEmail": "Check your email",
    "documentLabel": "Reset password",
    "emailSentDescription": "Check your inbox for password reset instructions.",
    "emailSentTitle": "Email sent!",
    "eyebrow": "Forgot password",
    "interstitialLede": "You’re signed in as <strong>{{email}}</strong> — you can change your password anytime from your profile. If you’ve forgotten your current password, we can still email you a reset link.",
    "lede": "Enter the email tied to your account and we’ll send instructions to reset it.",
    "recoveryLabel": "Recovery",
    "recoveryValue": "Email link",
    "resetAnyway": "Reset my password anyway",
    "sendDifferentAddress": "Send to a different address",
    "sendFailedDescription": "Please try again in a moment.",
    "sendFailedTitle": "Couldn’t send the reset email",
    "sending": "Sending…",
    "sentDocumentLabel": "Reset link sent",
    "sentLede": "Reset instructions are on their way to <strong>{{email}}</strong>. The link stays valid for one hour.",
    "sentSpamNote": "If it doesn’t arrive in a few minutes, check your spam folder.",
    "sentTitle": "We’ve sent the reset link.",
    "sentToLabel": "Sent to",
    "submit": "Send reset instructions",
    "title": "Reset your <em>password</em>."
  },
  "login": {
    "alreadySignedInLede": "You’re signed in as <strong>{{email}}</strong> — no need to sign in again. Head back to your account, or switch to a different one below.",
    "alternateLabel": "Apply to TRF",
    "alternatePrompt": "New to TRF?",
    "attemptsWarning_one": "({{count}} attempt remaining before your account is locked.)",
    "attemptsWarning_other": "({{count}} attempts remaining before your account is locked.)",
    "awaitingApprovalTitle": "Awaiting admin approval",
    "codeCancel": "Cancel",
    "codePlaceholder": "6-digit code",
    "codeSendFailedDescription": "Try again in a moment, or use your password.",
    "codeSendFailedTitle": "Couldn’t send the code",
    "codeSentDescription": "Check your phone for a 6-digit code.",
    "codeSentTitle": "Code sent",
    "documentLabel": "Sign in",
    "emailMeALink": "Email me a link",
    "enterCodeFromPhone": "Enter the code from your phone",
    "enterEmailFirstCode": "Type your email above, then request a code.",
    "enterEmailFirstLink": "Type your email above, then request a sign-in link.",
    "enterEmailFirstTitle": "Enter your email first",
    "eyebrow": "Sign in",
    "forgotPassword": "Forgot password?",
    "forLabel": "For",
    "forValue": "Returning families",
    "googleEyebrow": "Or use Google",
    "googleFailed": "Google sign-in didn’t work. Try again, or sign in with your password.",
    "googleFailedTitle": "Couldn’t sign in with Google",
    "googleNoAccount": "No TRF account uses this Google account.",
    "invalidCode": "Invalid code",
    "invalidEmailOrPassword": "Invalid email or password",
    "lede": "Sign in to pick up where you left off.",
    "linkSendFailedDescription": "Try again in a moment, or use your password.",
    "linkSendFailedTitle": "Couldn’t send the link",
    "linkSent": "Link sent",
    "linkSentDescription": "Check {{email}} for a one-click link. It expires in 15 minutes.",
    "linkSentTitle": "Sign-in link sent",
    "loginFailedTitle": "Login failed",
    "or": "or",
    "orApply": "or apply to TRF",
    "passwordlessCodeSent": "We’ve sent a 6-digit code to the phone on your profile.",
    "passwordlessDefault": "Get a one-click link by email, or a 6-digit code by text.",
    "passwordlessEyebrow": "Or sign in without a password",
    "passwordlessHint": "Type your email above first. The code goes to the phone on your account.",
    "passwordlessLinkSent": "We’ve sent a one-click sign-in link. It expires in 15 minutes.",
    "passwordRequired": "Password is required",
    "registrationNotApprovedTitle": "Registration not approved",
    "rememberMe": "Keep me signed in on this device",
    "sessionExpired": "Your session ended, so you were signed out. Sign in again to pick up where you left off.",
    "signIn": "Sign in",
    "signInAsSomeoneElse": "Sign in as someone else",
    "signInFailedTitle": "Sign-in failed",
    "signingIn": "Signing in…",
    "textMeACode": "Text me a code",
    "title": "Welcome <em>back</em>.",
    "verify": "Verify",
    "welcomeBackDescription": "You have successfully logged in.",
    "welcomeBackTitle": "Welcome back!"
  },
  "magicLink": {
    "accountNotActive": "This account is not active.",
    "backToSignIn": "Back to sign in",
    "blockedEyebrow": "Can’t sign in",
    "expiredDocumentLabel": "Link expired",
    "expiredEyebrow": "Link expired",
    "expiredLede": "{{message}} Links are single-use and expire after 15 minutes. Request a new one to continue.",
    "expiredTitle": "This sign-in link is no longer valid.",
    "failedLede": "Wait a minute and open the link again. If it still fails, go back to sign in and request a new link.",
    "failedTitle": "We couldn’t sign you in.",
    "inactiveLede": "Your TRF contact can turn it back on. A new sign-in link will not change this.",
    "invalidOrExpired": "Invalid or expired sign-in link",
    "missingToken": "This sign-in link is missing its token.",
    "oneMoment": "One moment",
    "replaceSessionContinue": "Continue",
    "replaceSessionDocumentLabel": "Switch account",
    "replaceSessionEyebrow": "Already signed in",
    "replaceSessionLede": "You’re signed in as {{name}}. This link signs in the account it was sent to, and signs you out.",
    "replaceSessionStay": "Stay signed in as {{name}}",
    "replaceSessionTitle": "Sign in with this link?",
    "signInFailed": "We couldn’t sign you in with this link.",
    "usePassword": "Use password instead",
    "verifyingDocumentLabel": "Signing you in",
    "verifyingLink": "Verifying your link.",
    "verifyingTitle": "Signing you in…"
  },
  "mfa": {
    "codeLabel": "Verification code",
    "codeResentEmail": "Check your email for a new code.",
    "codeResentSms": "Check your phone for a new code.",
    "codeResentTitle": "Code resent",
    "documentLabel": "Two-factor",
    "eyebrow": "Two-factor verification",
    "resendFailedDescription": "Please try again.",
    "resendFailedTitle": "Resend failed",
    "resendIn": "Resend in {{seconds}}s",
    "resendPrompt": "Didn’t get a code? Resend",
    "sentToEmail": "We sent a 6-digit code to your email. Enter it below to finish signing in.",
    "sentToPhone": "We sent a 6-digit code to your phone. Enter it below to finish signing in.",
    "stepLabel": "Step",
    "stepValue": "Verify code",
    "title": "Confirm it’s <em>you</em>.",
    "verificationFailedDescription": "Invalid or expired code. Please try again.",
    "verificationFailedTitle": "Verification failed",
    "verify": "Verify",
    "verifying": "Verifying…"
  },
  "mfaOnboarding": {
    "closing": "Closing in a moment…",
    "enable": "Enable Two-Factor Authentication",
    "enabledBody": "A code goes to your email or phone each time you sign in.",
    "enabledTitle": "Two-factor authentication enabled!",
    "enterCodeDescription": "Enter the 6-digit code sent to your email.",
    "enterCodeTitle": "Enter the code",
    "eyebrow": "Security",
    "invalidDescription": "Check your email and try again.",
    "invalidTitle": "Invalid code",
    "maybeLater": "Maybe later",
    "secureBody": "Add two-factor authentication to protect your account. A code goes to your email or phone each time you sign in.",
    "secureTitle": "Secure your account",
    "sendFailedDescription": "You can enable two-factor anytime via your profile → Security.",
    "sendFailedTitle": "Couldn’t send the code",
    "sendingCode": "Sending code…",
    "sentTo": "We sent a code to <strong>{{destination}}</strong>. Enter it below to finish.",
    "skipDescription": "You can enable 2FA anytime via your profile → Security.",
    "skipTitle": "Two-factor authentication",
    "verifyAndEnable": "Verify & Enable",
    "whyBody": "Pediatric cancer paperwork includes private medical and financial details. A one-time code at sign-in keeps your family’s data safe even if your password is leaked.",
    "whyTitle": "Why it matters"
  },
  "reset": {
    "backToSignIn": "Back to sign in",
    "confirmPasswordLabel": "Confirm new password",
    "continueToSignIn": "Continue to sign in",
    "continueWithReset": "Continue with the reset",
    "documentLabel": "Reset password",
    "eyebrow": "Set a new password",
    "failedDescription": "The reset link may have expired. Please try again.",
    "failedTitle": "Couldn’t reset your password",
    "interstitialLedeNoToken": "You’re signed in as <strong>{{email}}</strong>, and this reset link is missing or incomplete. Head back to your account, or request a new link if you still need one.",
    "interstitialLedeWithToken": "You’re signed in as <strong>{{email}}</strong>. Head back to your account — or continue with this reset link. Resetting your password signs you out on all devices, and you’ll sign back in with the new one.",
    "invalidDocumentLabel": "Invalid reset link",
    "invalidEyebrow": "Link expired",
    "invalidLede": "Reset links are single-use and expire after one hour. Request a new one to continue.",
    "invalidLinkDescription": "Please request a new password reset link.",
    "invalidLinkTitle": "Invalid reset link",
    "invalidTitle": "This reset link is no longer valid.",
    "lede": "Use at least 8 characters with an uppercase letter, a lowercase letter, and a number.",
    "newPasswordHelper": "Must be at least 8 characters with uppercase, lowercase, and a number.",
    "newPasswordLabel": "New password",
    "passwordLowercase": "Password must contain at least one lowercase letter",
    "passwordMin": "Password must be at least 8 characters",
    "passwordNumber": "Password must contain at least one number",
    "passwordsMismatch": "Passwords do not match",
    "passwordUppercase": "Password must contain at least one uppercase letter",
    "requestNewLink": "Request a new link",
    "requestNewResetLink": "Request a new reset link",
    "resetting": "Resetting…",
    "stepLabel": "Step",
    "stepValue": "Set new password",
    "submit": "Reset password",
    "successDescription": "You can now sign in with your new password.",
    "successDocumentLabel": "Password reset",
    "successEyebrow": "Reset complete",
    "successHeading": "Your password is updated.",
    "successLede": "Sign in with your new password to pick things back up.",
    "successTitle": "Password reset successful!",
    "title": "Choose a new <em>password</em>."
  },
  "setNew": {
    "documentLabel": "New password",
    "expiredDescription": "This link has expired. Sign in again.",
    "expiredTitle": "Sign in again",
    "eyebrow": "One more step",
    "failedDescription": "Your password was not changed. Please try again.",
    "failedTitle": "Couldn’t set your password",
    "lede": "Before you continue, choose a new password for your account. Use at least 8 characters with an uppercase letter, a lowercase letter, and a number.",
    "saving": "Saving…",
    "stepLabel": "Step",
    "stepValue": "New password",
    "submit": "Save and continue",
    "title": "Choose a <em>new</em> password.",
    "unchanged": "Choose a password different from your current one."
  },
  "shared": {
    "alreadySignedIn": "Already signed in",
    "alreadySignedInTitle": "You’re already signed in.",
    "checkingSession": "Checking your session",
    "emailLabel": "Email",
    "emailPlaceholder": "your@email.com",
    "goToMyAccount": "Go to my account",
    "invalidEmail": "Invalid email address",
    "passwordLabel": "Password",
    "signedInAs": "Signed in as",
    "unreachable": "We can’t reach TRF right now. Trying again…",
    "unreachableRetry": "Try again",
    "yourAccount": "your account"
  }
}
